module.exports = __webpack_public_path__ + "static/media/Desktop_Purpose_30.a699aabf.png";